import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

const getWrappedMessage = (message: ReactElement) => (
    <div className='multi-selection-dropdown__placeholder'>
        <div>
            {message}
        </div>
    </div>
);

export const deliveryTeamNoItems = getWrappedMessage(
    <FormattedMessage
        id='oe.delivery.emptyList'
        defaultMessage="You don't have any Delivery Team members yet."
        description='No Delivery Team label text'
    />
);

export const deliveryTeamNoSearchResult = getWrappedMessage(
    <FormattedMessage
    id='oe.delivery.notFound'
    defaultMessage='No Delivery Team members found.'
    description='No Delivery Team label text'
    />
);

export const coordinatorsNoItems = getWrappedMessage(
    <FormattedMessage
        id='oe.coordinators.noCoordinatorsInAccount'
        defaultMessage='There are no Coordinators in your Account'
        description='No Delivery Team label text'
    />
);

export const coordinatorsNoSearchResult = getWrappedMessage(
    <FormattedMessage
        id='oe.coordinators.notFound'
        defaultMessage='No Coordinators found.'
        description='Text label'
    />
);

export const accountsNoItems = getWrappedMessage(
    <FormattedMessage
        id='oe.accounts.emptyList'
        defaultMessage="You don't have any Accounts members yet."
        description='No Accounts label text'
    />
);

export const accountsNoSearchResult = getWrappedMessage(
    <FormattedMessage
        id='oe.accounts.notFound'
        defaultMessage='No Accounts found.'
        description='No Accounts label text'
    />
);

export const eventLinkNoSearchResult = getWrappedMessage(
    <FormattedMessage
        id='oe.link.notFound'
        defaultMessage='No Links found.'
        description='No Links label text'
    />
);

export const eventRegionNoSearchResult = getWrappedMessage(
    <FormattedMessage
        id='oe.eventTracker.regionsNotFound'
        defaultMessage='No Regions found.'
        description='No Regions label text'
    />
);

export const eventBusinessLineNoSearchResult = getWrappedMessage(
    <FormattedMessage
        id='oe.eventTracker.businessLinesNotFound'
        defaultMessage='No business lines found.'
        description='No business lines label text'
    />
);

export const eventTypeNoSearchResult = getWrappedMessage(
    <FormattedMessage
        id='oe.eventType.notFound'
        defaultMessage='No Event types found.'
        description='No Accounts label text'
    />
);
